import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Typography from '@mui/material/Typography';
import { useContext, useState } from 'react';
import IconProvider from '../../../../components/icons/IconProvider';
import { SimulatorContext, ISimulatorContext } from '../../../../context/SimulatorProvider';
import { Constants } from '../../../../data/constants';
import { useProductsQuery } from '../../../../hooks/useProductsQuery';
import "./StationInfos.css";

function StationInfos() {
    const { codeTotal } = useContext(SimulatorContext) as ISimulatorContext;
    const codeTotalWithoutPrefix = codeTotal.split(Constants.CODE_PREFIX).pop()
    const productDetails = useProductsQuery(codeTotalWithoutPrefix!)
    const stationInfos = productDetails.data && productDetails.data.stationInfos
    const [accordionOpen, setAccordionOpen] = useState<boolean>(false)

    if (productDetails.isSuccess && stationInfos && codeTotal) {
        return (
            <>
                <ClickAwayListener onClickAway={() => setAccordionOpen(false)}>
                    <Accordion expanded={accordionOpen} onChange={() => setAccordionOpen((prevOpen) => !prevOpen)} disableGutters square>
                        <AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
                            <div className='station-infos-summary'>
                                <IconProvider id="localisation" color="red-filter" size="medium" />
                                <div className='station-infos-summary-text'>
                                    <Typography variant="h5" color="secondary">
                                        {codeTotal}
                                    </Typography>
                                    <span >
                                        {stationInfos.placeName}
                                    </span>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='accordion-details'>
                                <div className='station-infos-summary-text'>
                                    <span className='grey-text'>{stationInfos.address}, {stationInfos.zipCode}, {stationInfos.countryKey}</span>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </ClickAwayListener>
            </>
        )
    }

    return <></>
}

export default StationInfos;